import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { MaterialsListPage } from './MaterialsListPage'
import { AddMaterialPage } from './AddMaterialPage'
import { EditMaterialPage } from './EditMaterialPage'
import { MaterialsStockAdjustmentPage } from './MaterialsStockAdjustmentPage'

export const MaterialsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<MaterialsListPage />} />
      <Route path="add" element={<AddMaterialPage />} />
      <Route path="edit/:id" element={<EditMaterialPage />} />
      <Route path="stock-adjustment" element={<MaterialsStockAdjustmentPage />} />
      <Route path="adjustment" element={<MaterialsStockAdjustmentPage />} />
    </Routes>
  )
}